var sideCatalog = {};

/* Side catalog — vertical board-catalog strip on the right edge while reading a
   thread. Ported 2026-08-27 from the legacy FE (present since LynxChan FE
   2.3.0; dropped during KohlNumbra's early restructure).

   KN delta vs legacy: cells are PLAIN LINKS, not client-side thread swaps.
   Legacy's in-place swap (transitionThread) reused posting.setPostInnerElements
   on the existing server-rendered OP cell — that function is KN-internal for
   JS-built reply cells and assumes slots KN strips from non-staff OPs
   (.panelASN/.panelBypassId/.panelRange, .watchButton, …), so it throws on
   every click. A full page load per click is exactly how every other thread
   link on the site works: zero DOM assumptions, correct rendering guaranteed. */

sideCatalog.init = function() {

  document.getElementById('sideCatalogRefreshButton').onclick = sideCatalog.refreshSideCatalog;

  sideCatalog.sideCatalogBody = document.getElementById('sideCatalogBody');
  sideCatalog.mainBody = document.getElementById('mainPanel');

  // #bottomNav is a direct child of <body>, OUTSIDE #mainPanel, so it never
  // receives the open-state shrink — constrain it in parallel or its right
  // edge slides under the fixed panel (operator report 2026-08-27).
  sideCatalog.bottomNav = document.getElementById('bottomNav');

  var setMainWidthClass = function(open) {
    sideCatalog.mainBody.className = open ? 'mainPanelWithSideCatalog' : '';
    if (sideCatalog.bottomNav) {
      sideCatalog.bottomNav.classList.toggle('sideCatalogOpen', open);
    }
    // Clear any inline width left by a resize drag — an inline style beats
    // the class, so closing with one stuck would reserve the panel's column
    // as blank space (operator report 2026-08-27).
    sideCatalog.mainBody.style.width = '';
    if (sideCatalog.bottomNav) {
      sideCatalog.bottomNav.style.width = '';
    }
  };

  sideCatalog.sideCatalogDiv = document.getElementById('sideCatalogDiv');

  // The panel's top is a fixed CSS constant (_sideCatalog.scss: top:90px), sized
  // to clear the worst-case three-line nav (board row + options row + ad-block
  // row). No JS measures the nav height — the panel simply never sits above that
  // line, and its z-index is below #topNav's so even a mis-estimate can only hide
  // it BEHIND the nav, never paint over it.

  if (!localStorage.hideSideCatalog) {
    // 'flex', not 'block': the panel is a flex column (pinned header +
    // scrolling body) and this inline style OVERRIDES the stylesheet's
    // display:flex — 'block' silently un-flexed it and killed the scroller.
    sideCatalog.sideCatalogDiv.style.display = 'flex';
    setMainWidthClass(true);
  } else {
    // explicit inline state so the toggle's display!=='none' check can't
    // misread the initial (class-hidden, no-inline-style) state as visible
    sideCatalog.sideCatalogDiv.style.display = 'none';
    setMainWidthClass(false);
  }

  sideCatalog.refreshSideCatalog();

  document.getElementById('closeSideCatalogButton').onclick = function() {
    sideCatalog.sideCatalogDiv.style.display = 'none';
    setMainWidthClass(false);
    localStorage.setItem('hideSideCatalog', true);
  }

  // Left-edge drag grip: shrink the panel below its 20% default (min 10%) —
  // operator: no growing it larger. The CSS left:80% is static, so left must be
  // set from the width or the panel overlaps the page while dragging.
  var setPanelWidth = function(pct) {
    pct = Math.max(10, Math.min(20, pct));

    sideCatalog.sideCatalogDiv.style.width = pct + '%';
    sideCatalog.sideCatalogDiv.style.left = (100 - pct) + '%';
    sideCatalog.mainBody.style.width = (100 - pct) + '%';
    if (sideCatalog.bottomNav) {
      sideCatalog.bottomNav.style.width = (100 - pct) + '%';
    }
    localStorage.setItem('sideCatalogWidth', pct);
  };

  // Apply the stored width ONLY when the panel is open — running it while
  // hidden would pin #mainPanel to an inline width and reserve a blank
  // column on every load (operator report 2026-08-27).
  var storedWidth = parseFloat(localStorage.getItem('sideCatalogWidth'));

  if (storedWidth && !localStorage.hideSideCatalog) {
    setPanelWidth(storedWidth);
  }

  var resizeHandle = document.createElement('span');
  resizeHandle.id = 'sideCatalogResizeHandle';
  resizeHandle.title = 'Drag to resize (shrinks only)';
  sideCatalog.sideCatalogDiv.appendChild(resizeHandle);

  resizeHandle.onmousedown = function(e) {
    e.preventDefault();
    document.body.style.userSelect = 'none';

    var onMove = function(ev) {
      setPanelWidth(100 - (ev.clientX / window.innerWidth) * 100);
    };

    var onUp = function() {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  // KN nav: the catalog link is a CLASS (.navCatalog), not id #navCatalog —
  // anchor on the top-right bar's copy (rightBarThread.njk) so we don't touch
  // the secondary bar or bottom-nav links.
  var catalogButton = document.querySelector('#navOptionsSpanThread .navCatalog');

  if (!catalogButton) {
    return;
  }

  var sideCatalogButton = document.createElement('a');
  sideCatalogButton.className = 'sideCatalogToggle';
  sideCatalogButton.id = 'navSideCatalog';
  sideCatalogButton.title = 'Show/hide side catalog';

  // True TOGGLE, not just re-show: the panel's X is the only other way to
  // hide it, and for ad-blocker users the grown top nav used to cover it —
  // a show-only button left them with a panel they could never dismiss.
  sideCatalogButton.onclick = function() {
    // Visible state is display:flex (see init) — compare against 'none',
    // not a literal value, so the show/hide logic can't drift from it.
    if (sideCatalog.sideCatalogDiv.style.display !== 'none') {
      sideCatalog.sideCatalogDiv.style.display = 'none';
      setMainWidthClass(false);
      localStorage.setItem('hideSideCatalog', true);
    } else {
      setMainWidthClass(true);
      sideCatalog.sideCatalogDiv.style.display = 'flex';
      localStorage.removeItem('hideSideCatalog');
      // Re-apply the stored width — closing cleared it.
      var w = parseFloat(localStorage.getItem('sideCatalogWidth'));
      if (w) { setPanelWidth(w); }
    }
  };

  catalogButton.parentNode.insertBefore(sideCatalogButton,
      catalogButton.nextSibling);

  catalogButton.parentNode.insertBefore(document.createTextNode(' '),
      catalogButton.nextSibling);

  var divider = document.createElement('span');
  divider.innerHTML = '/';
  catalogButton.parentNode.insertBefore(divider, catalogButton.nextSibling);

  catalogButton.parentNode.insertBefore(document.createTextNode(' '),
      catalogButton.nextSibling);

};

sideCatalog.addSideCatalogThread = function(thread) {

  var cell = document.createElement('a');
  cell.href = '/' + api.boardUri + '/res/' + thread.threadId + '.html';

  if (thread.thumb) {

    var img = document.createElement('img');

    img.src = thread.thumb;

    if (thread.animatedThumb) {
      img.dataset.animatedThumb = thread.animatedThumb;
      if (settings.get('autoPlayAnimations')) {
        img.src = thread.animatedThumb;
      }
    }

    cell.appendChild(img);
  }

  var linkContent = document.createElement('span');
  linkContent.className = 'sideCatalogCellText';
  cell.appendChild(linkContent);

  var upperText = document.createElement('span');
  var lowerText = document.createElement('span');

  linkContent.appendChild(upperText);
  linkContent.appendChild(lowerText);

  upperText.innerHTML = (thread.subject || (thread.message.replace(/[<>'"]/g,
      function(match) {
        return api.htmlReplaceTable[match];
      }).substring(0, 128) || thread.threadId));

  lowerText.innerHTML = 'R: ' + (thread.postCount || 0) + ' / F: '
      + (thread.fileCount || 0);

  sideCatalog.sideCatalogBody.appendChild(cell);

  if (api.threadId === thread.threadId) {
    // KN's own .markedPost class so every theme's highlight palette applies
    // (post-cell layout side effects are neutralized in _sideCatalog.scss).
    cell.className = 'sideCatalogCell markedPost';
    cell.scrollIntoView();
    sideCatalog.selectedThreadCell = cell;
  } else {
    cell.className = 'sideCatalogCell';
  }

};

sideCatalog.processCatalogData = function(data) {

  sideCatalog.sideCatalogBody.innerHTML = '';

  var boardData = hiding.storedHidingData[api.boardUri];

  for (var i = 0; i < data.length; i++) {

    var thread = data[i];

    if ((boardData && boardData.threads.indexOf(thread.threadId.toString()) > -1)) {
      continue;
    }

    sideCatalog.addSideCatalogThread(thread);
  }

};

sideCatalog.refreshSideCatalog = function() {

  if (sideCatalog.refreshingSideCatalog) {
    return;
  }

  sideCatalog.refreshingSideCatalog = true;

  api.localRequest('/' + api.boardUri + '/catalog.json', function(error, data) {

    sideCatalog.refreshingSideCatalog = false;

    if (error) {
      return;
    }

    sideCatalog.processCatalogData(JSON.parse(data));

  });

};

// Desktop-only (operator 2026-08-27: not available on mobile/tablet). KN's
// api.mobile cutoff is <812px, but the operator's ≥812px device read as
// cramped-with-panel — require a true desktop width. Evaluated at load like
// api.mobile; a resize needs a reload to flip (same semantics as everywhere
// else in KN).
if (window.innerWidth >= 1024) {
  sideCatalog.init();
}
